import { ArrowDropUpSharp } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { formatString } from '@shared/commonFunctions';
import { StyledArrow } from '@styles/StyledTextField';
import { LenderSelectionDropdown } from '@styles/Tools/LenderControl/LenderControlsHeaderStyles';

interface ILenderSelectorProps {
    open: boolean;
    typoRef: React.RefObject<HTMLDivElement>;
    id?: string;
    isActive: boolean;
    selectedLenderName?: string;
    handleOpenSelectionsPopper: () => void;     
}

export const LenderSelector = ({
    open,
    typoRef,
    id,
    isActive,
    selectedLenderName,
    handleOpenSelectionsPopper,
}: ILenderSelectorProps) => {
    return (
        <>
            <Typography sx={{ fontWeight: 600 }}>Lender:</Typography>
            <LenderSelectionDropdown ref={typoRef} isActive={isActive} aria-describedby={id} onClick={handleOpenSelectionsPopper}>
                {selectedLenderName ? formatString(selectedLenderName)  : 'Select Lender'}
                <StyledArrow open={open}>
                    <ArrowDropUpSharp />
                </StyledArrow>
            </LenderSelectionDropdown>
        </>
    );
};